<template>
    <div class="row text-left">
        <div class="col-12">
            <div class="row">
                <div class="col-sm-12">
                    <h4>Pagamento com Wirecard</h4>
                </div>

                <div class="col-sm-12 mt-2">
                    <div class="alert alert-danger">
                        Este método de pagamento é válido apenas para usuários residentes no <b>Brasil</b>. Caso você esteja em outro país, realize o pagamento através do Paypal, Neteller ou Skrill.
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label for="full_name" class="control-label">Nome Completo</label>
                        <input type="text" class="form-control" name="full_name" v-model='form.full_name' required/>
                        <div class="help-block with-errors"></div>
                    </div>

                    <div class="form-group">
                        <label for="email" class="control-label">Email</label>
                        <input type="email" name="email" class="form-control" v-model="form.email" required/>
                        <div class="help-block with-errors"></div>
                    </div>

                    <div class="form-group">
                        <label for="phone" class="control-label">Telefone</label>
                        <input type="text" data-phone="phone" name="phone" v-model="form.phone" class="form-control phone" required/>
                        <div class="help-block with-errors"></div>
                    </div>

                    <div class="form-group">
                        <label for="birthdate" class="control-label">Data de Nascimento</label>
                        <input type="text" name="birthdate" class="form-control date" v-model="form.birthdate" required/>
                        <div class="help-block with-errors"></div>
                    </div>

                    <div class="form-group">
                        <label for="document" class="control-label">CPF</label>
                        <input type="text" data-cpf="cpf" name="document" class="form-control cpf" v-model="form.cpf" required/>
                        <div class="help-block with-errors"></div>
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label for="zipcode" class="control-label">Cep</label><br>
                        <input type="text" name="zipcode" class="form-control cep" id="cep_field" required/> <i id="cep_loading" class="fa fa-spin fa-circle-o-notch" aria-hidden="true"></i>
                        <div class="help-block with-errors"></div>
                    </div>

                    <div class="form-group">
                        <label for="street" class="control-label">Rua</label>
                        <input type="text" name="street" class="form-control" required/>
                        <div class="help-block with-errors"></div>
                    </div>

                    <div class="form-group">
                        <label for="street_number" class="control-label">Número</label>
                        <input type="text" name="street_number" class="form-control" required/>
                        <div class="help-block with-errors"></div>
                    </div>

                    <div class="form-group">
                        <label for="street_complement" class="control-label">Complemento</label>
                        <input type="text" name="street_complement" class="form-control"/>
                        <div class="help-block with-errors"></div>
                    </div>

                    <div class="form-group">
                        <label for="district" class="control-label">Bairro</label>
                        <input type="text" name="district" class="form-control" required/>
                        <div class="help-block with-errors"></div>
                    </div>

                    <div class="form-group">
                        <label for="city" class="control-label">Cidade</label>
                        <input type="text" name="city" class="form-control" required/>
                        <div class="help-block with-errors"></div>
                    </div>

                    <div class="form-group">
                        <label for="state" class="control-label">Estado</label>
                        <input type="text" name="state" class="form-control" required/>
                        <div class="help-block with-errors"></div>
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                    <div class="card">
                        <div class="card-header bg-light">
                            <h4>Confirme o Pagamento</h4>
                        </div>
                        <div class="card-body">
                            <h4>USD {{ value }}</h4>
                            <h5>{{ plan.description }}</h5>
                            <div class="row mt-4 mb-4">
                                <div class="col-12">
                                    <label for="discount">Possui um cupom de desconto?</label>
                                    <div class="input-group">
                                        <input type="text" name="discount_code" class="form-control" v-model="discount_code" />
                                        <span class="input-group-btn">
                                            <button @click="verifyDiscountCode" class="btn btn-light" type="button" id="discount-submit-paypal">Aplicar</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <button @click="submit()" type="button" class="btn btn-lg btn-block btn-success">Realizar Pagamento</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['plan'],
    data() {
        return {
            form: {
                full_name: '',
                email: '',
                phone: '',
                birthdate: '',
                cpf: ''
            },
            discount_code: '',
            value: this.plan.value,
            discount_obj: null,
        }
    },
    methods: {
        verifyDiscountCode() {
            axios.post('discount-code', {discount_code: this.discount_code, value: this.plan.value})
                .then(result => {
                    if (result) {
                        this.value = result.price_final;
                        this.$toast.success('Código de desconto aplicado com sucesso!');
                    } else {
                        this.$toast.error('Código inválido ou inexistente!');
                    }
                });
        },
        submit() {
            axios.post('submit-payment', {
                fk_plan: this.plan.id,
                discount_code: this.discount_code,
                method: 'wirecard'})
                .then(result => {
                    if (result.redirect) {
                        location.href = result.redirect;
                    }
            });
        }
    }
}
</script>

<style>

</style>